module.exports = __webpack_public_path__ + "img/badge_edicola.fcba021b.jpg";